'use strict';
import { Layout, Spin } from 'antd';
import React from 'react';

const { Content, Header } = Layout;

const LoadingLayout = ({ children, ...props }) => {
	return (
		<div>
			<Header className="mobile header-wrapper">
				<div className="scrollable-container">
					<a href='/' className='logo-ada-focus'>
						<img className='top-text--logo' alt="Yes.Fit Header Logo" title="Go to Yes.Fit Home" width='50' height='50' src='https://asset.yes.fit/homepage/yf-logo-web.png' />
					</a>

					<div className="shopping-cart-items">
						<img src="https://asset.yes.fit/homepage/web-menu-icon-v3.png" width='50' height='50' className="menu-button-img" />
					</div>
				</div>
			</Header>
			<Content className="main-body" style={{ minHeight: '90vh' }}>
				<div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItem: 'center', textAlign: 'center', marginTop: 50 }}>
					<Spin
						size='large'
						spinning={true}
					/>
				</div>
			</Content>
		</div>
	);
}

export default LoadingLayout;
